
export default {
    LOAD_ALL_HEALTH_INDEXES_REQUEST: 'LOAD_ALL_HEALTH_INDEXES_REQUEST',
    LOAD_ALL_HEALTH_INDEXES: 'LOAD_ALL_HEALTH_INDEXES',
  
    ADD_HEALTH_INDEX: 'ADD_HEALTH_INDEX',
    UPDATE_HEALTH_INDEX: 'UPDATE_HEALTH_INDEX',
    GET_HEALTH_INDEX_BY_ID: 'GET_HEALTH_INDEX_BY_ID',
    SET_HEALTH_INDEX_DEVICES: 'SET_HEALTH_INDEX_DEVICES',
    SET_HEALTH_INDEX_TAGS: 'SET_HEALTH_INDEX_TAGS',
    // LOAD_USER_REQUEST: 'LOAD_USER_REQUEST',
    // LOAD_USER: 'LOAD_USER',
  
    // LOAD_GROUPS_BY_USER_REQUEST: 'LOAD_GROUPS_BY_USER_REQUEST',
    // LOAD_GROUPS_BY_USER: 'LOAD_GROUPS_BY_USER',
  
    CREATE_HEALTH_INDEX: 'CREATE_HEALTH_INDEX',
    // UPDATE_USER: 'UPDATE_USER',
    DELETE_HEALTH_INDEX: 'DELETE_HEALTH_INDEX',
    SET_CREATED_TAG_ID: 'SET_CREATED_TAG_ID',
    // SEND_MAIL: 'SEND_MAIL',
    // DELETE_USER_FROM_GROUP_UV: 'DELETE_USER_FROM_GROUP_UV',
    // USER_UPDATE_GROUP: 'USER_UPDATE_GROUP',
  }